import React from "react";
import "./NewChatFABButton.css";
import { IoAddOutline } from "react-icons/io5";

type props = {
  onPress: () => void;
};

export const NewChatFABButton: React.FC<props> = ({ onPress }) => {
  return (
    <div onClick={onPress} className="new-chat-btn-container">
      <IoAddOutline color="white" size={25} />
    </div>
  );
};
